const COUNTRIES: { title: string; value: string }[] = [
  { title: "Afghanistan", value: "Afghanistan" },
  { title: "Albania", value: "Albania" },
  { title: "Algeria", value: "Algeria" },
  { title: "American Samoa", value: "American Samoa" },
  { title: "Andorra", value: "Andorra" },
  { title: "Angola", value: "Angola" },
  { title: "Anguilla", value: "Anguilla" },
  { title: "Argentina", value: "Argentina" },
  { title: "Armenia", value: "Armenia" },
  { title: "Aruba", value: "Aruba" },
  { title: "Australia", value: "Australia" },
  { title: "Austria", value: "Austria" },
  { title: "Azerbaijan", value: "Azerbaijan" },
  { title: "Bahamas", value: "Bahamas" },
  { title: "Bahrain", value: "Bahrain" },
  { title: "Bangladesh", value: "Bangladesh" },
  { title: "Barbados", value: "Barbados" },
  { title: "Belarus", value: "Belarus" },
  { title: "Belgium", value: "Belgium" },
  { title: "Belize", value: "Belize" },
  { title: "Benin", value: "Benin" },
  { title: "Bermuda", value: "Bermuda" },
  { title: "Bhutan", value: "Bhutan" },
  { title: "Bolivia", value: "Bolivia" },
  { title: "Bosnia and Herzegovina", value: "Bosnia and Herzegovina" },
  { title: "Botswana", value: "Botswana" },
  { title: "Brazil", value: "Brazil" },
  { title: "British Virgin Islands", value: "British Virgin Islands" },
  { title: "Brunei", value: "Brunei" },
  { title: "Bulgaria", value: "Bulgaria" },
  { title: "Burkina Faso", value: "Burkina Faso" },
  { title: "Burundi", value: "Burundi" },
  { title: "Cambodia", value: "Cambodia" },
  { title: "Cameroon", value: "Cameroon" },
  { title: "Canada", value: "Canada" },
  { title: "Cape Verde", value: "Cape Verde" },
  { title: "Cayman Islands", value: "Cayman Islands" },
  { title: "Central African Republic", value: "Central African Republic" },
  { title: "Chad", value: "Chad" },
  { title: "Chile", value: "Chile" },
  { title: "China", value: "China" },
  { title: "Columbia", value: "Columbia" },
  { title: "Comoros", value: "Comoros" },
  { title: "Cook Islands", value: "Cook Islands" },
  { title: "Costa Rica", value: "Costa Rica" },
  { title: "Croatia", value: "Croatia" },
  { title: "Cuba", value: "Cuba" },
  { title: "Curacao", value: "Curacao" },
  { title: "Cyprus", value: "Cyprus" },
  { title: "Czech Republic", value: "Czech Republic" },
  { title: "Democratic Republic of the Congo", value: "Democratic Republic of the Congo" },
  { title: "Denmark", value: "Denmark" },
  { title: "Djibouti", value: "Djibouti" },
  { title: "Dominica", value: "Dominica" },
  { title: "Dominican Republic", value: "Dominican Republic" },
  { title: "East Timor", value: "East Timor" },
  { title: "Ecuador", value: "Ecuador" },
  { title: "Egypt", value: "Egypt" },
  { title: "El Salvador", value: "El Salvador" },
  { title: "Eritrea", value: "Eritrea" },
  { title: "Estonia", value: "Estonia" },
  { title: "Ethiopia", value: "Ethiopia" },
  { title: "Faroe Islands", value: "Faroe Islands" },
  { title: "Fiji", value: "Fiji" },
  { title: "Finland", value: "Finland" },
  { title: "France", value: "France" },
  { title: "French Polynesia", value: "French Polynesia" },
  { title: "Gabon", value: "Gabon" },
  { title: "Gambia", value: "Gambia" },
  { title: "Georgia", value: "Georgia" },
  { title: "Germany", value: "Germany" },
  { title: "Ghana", value: "Ghana" },
  { title: "Greece", value: "Greece" },
  { title: "Greenland", value: "Greenland" },
  { title: "Grenada", value: "Grenada" },
  { title: "Guam", value: "Guam" },
  { title: "Guatemala", value: "Guatemala" },
  { title: "Guernsey", value: "Guernsey" },
  { title: "Guinea", value: "Guinea" },
  { title: "Guinea-Bissau", value: "Guinea-Bissau" },
  { title: "Guyana", value: "Guyana" },
  { title: "Haiti", value: "Haiti" },
  { title: "Honduras", value: "Honduras" },
  { title: "Hong Kong", value: "Hong Kong" },
  { title: "Hungary", value: "Hungary" },
  { title: "Iceland", value: "Iceland" },
  { title: "India", value: "India" },
  { title: "Indonesia", value: "Indonesia" },
  { title: "Iran", value: "Iran" },
  { title: "Iraq", value: "Iraq" },
  { title: "Ireland", value: "Ireland" },
  { title: "Isle of Man", value: "Isle of Man" },
  { title: "Israel", value: "Israel" },
  { title: "Italy", value: "Italy" },
  { title: "Ivory Coast", value: "Ivory Coast" },
  { title: "Jamaica", value: "Jamaica" },
  { title: "Japan", value: "Japan" },
  { title: "Jersey", value: "Jersey" },
  { title: "Jordan", value: "Jordan" },
  { title: "Kazakhstan", value: "Kazakhstan" },
  { title: "Kenya", value: "Kenya" },
  { title: "Kiribati", value: "Kiribati" },
  { title: "Kosovo", value: "Kosovo" },
  { title: "Kuwait", value: "Kuwait" },
  { title: "Kyrgyzstan", value: "Kyrgyzstan" },
  { title: "Laos", value: "Laos" },
  { title: "Latvia", value: "Latvia" },
  { title: "Lebanon", value: "Lebanon" },
  { title: "Lesotho", value: "Lesotho" },
  { title: "Liberia", value: "Liberia" },
  { title: "Libya", value: "Libya" },
  { title: "Liechtenstein", value: "Liechtenstein" },
  { title: "Lithuania", value: "Lithuania" },
  { title: "Luxembourg", value: "Luxembourg" },
  { title: "Macau", value: "Macau" },
  { title: "Macedonia", value: "Macedonia" },
  { title: "Madagascar", value: "Madagascar" },
  { title: "Malawi", value: "Malawi" },
  { title: "Malaysia", value: "Malaysia" },
  { title: "Maldives", value: "Maldives" },
  { title: "Mali", value: "Mali" },
  { title: "Malta", value: "Malta" },
  { title: "Marshall Islands", value: "Marshall Islands" },
  { title: "Mauritania", value: "Mauritania" },
  { title: "Mauritius", value: "Mauritius" },
  { title: "Mayotte", value: "Mayotte" },
  { title: "Mexico", value: "Mexico" },
  { title: "Micronesia", value: "Micronesia" },
  { title: "Moldova", value: "Moldova" },
  { title: "Monaco", value: "Monaco" },
  { title: "Mongolia", value: "Mongolia" },
  { title: "Montenegro", value: "Montenegro" },
  { title: "Morocco", value: "Morocco" },
  { title: "Mozambique", value: "Mozambique" },
  { title: "Myanmar", value: "Myanmar" },
  { title: "Namibia", value: "Namibia" },
  { title: "Nepal", value: "Nepal" },
  { title: "Netherlands", value: "Netherlands" },
  { title: "Netherlands Antilles", value: "Netherlands Antilles" },
  { title: "New Caledonia", value: "New Caledonia" },
  { title: "New Zealand", value: "New Zealand" },
  { title: "Nicaragua", value: "Nicaragua" },
  { title: "Niger", value: "Niger" },
  { title: "Nigeria", value: "Nigeria" },
  { title: "North Korea", value: "North Korea" },
  { title: "Northern Mariana Islands", value: "Northern Mariana Islands" },
  { title: "Norway", value: "Norway" },
  { title: "Oman", value: "Oman" },
  { title: "Pakistan", value: "Pakistan" },
  { title: "Palestine", value: "Palestine" },
  { title: "Panama", value: "Panama" },
  { title: "Papua New Guinea", value: "Papua New Guinea" },
  { title: "Paraguay", value: "Paraguay" },
  { title: "Peru", value: "Peru" },
  { title: "Philippines", value: "Philippines" },
  { title: "Poland", value: "Poland" },
  { title: "Portugal", value: "Portugal" },
  { title: "Puerto Rico", value: "Puerto Rico" },
  { title: "Qatar", value: "Qatar" },
  { title: "Republic of the Congo", value: "Republic of the Congo" },
  { title: "Reunion", value: "Reunion" },
  { title: "Romania", value: "Romania" },
  { title: "Russia", value: "Russia" },
  { title: "Rwanda", value: "Rwanda" },
  { title: "Saint Kitts and Nevis", value: "Saint Kitts and Nevis" },
  { title: "Saint Lucia", value: "Saint Lucia" },
  { title: "Saint Martin", value: "Saint Martin" },
  { title: "Saint Pierre and Miquelon", value: "Saint Pierre and Miquelon" },
  { title: "Saint Vincent and the Grenadines", value: "Saint Vincent and the Grenadines" },
  { title: "Samoa", value: "Samoa" },
  { title: "San Marino", value: "San Marino" },
  { title: "Sao Tome and Principe", value: "Sao Tome and Principe" },
  { title: "Saudi Arabia", value: "Saudi Arabia" },
  { title: "Senegal", value: "Senegal" },
  { title: "Serbia", value: "Serbia" },
  { title: "Seychelles", value: "Seychelles" },
  { title: "Sierra Leone", value: "Sierra Leone" },
  { title: "Singapore", value: "Singapore" },
  { title: "Sint Maarten", value: "Sint Maarten" },
  { title: "Slovakia", value: "Slovakia" },
  { title: "Slovenia", value: "Slovenia" },
  { title: "Solomon Islands", value: "Solomon Islands" },
  { title: "Somalia", value: "Somalia" },
  { title: "South Africa", value: "South Africa" },
  { title: "South Korea", value: "South Korea" },
  { title: "South Sudan", value: "South Sudan" },
  { title: "Spain", value: "Spain" },
  { title: "Sri Lanka", value: "Sri Lanka" },
  { title: "Sudan", value: "Sudan" },
  { title: "Suriname", value: "Suriname" },
  { title: "Swaziland", value: "Swaziland" },
  { title: "Sweden", value: "Sweden" },
  { title: "Switzerland", value: "Switzerland" },
  { title: "Syria", value: "Syria" },
  { title: "Taiwan", value: "Taiwan" },
  { title: "Tajikistan", value: "Tajikistan" },
  { title: "Tanzania", value: "Tanzania" },
  { title: "Thailand", value: "Thailand" },
  { title: "Togo", value: "Togo" },
  { title: "Tonga", value: "Tonga" },
  { title: "Trinidad and Tobago", value: "Trinidad and Tobago" },
  { title: "Tunisia", value: "Tunisia" },
  { title: "Turkey", value: "Turkey" },
  { title: "Turkmenistan", value: "Turkmenistan" },
  { title: "Turks and Caicos Islands", value: "Turks and Caicos Islands" },
  { title: "Tuvalu", value: "Tuvalu" },
  { title: "U.S. Virgin Islands", value: "U.S. Virgin Islands" },
  { title: "Uganda", value: "Uganda" },
  { title: "Ukraine", value: "Ukraine" },
  { title: "United Arab Emirates", value: "United Arab Emirates" },
  { title: "United Kingdom", value: "United Kingdom" },
  { title: "United States", value: "United States" },
  { title: "Uruguay", value: "Uruguay" },
  { title: "Uzbekistan", value: "Uzbekistan" },
  { title: "Vanuatu", value: "Vanuatu" },
  { title: "Venezuela", value: "Venezuela" },
  { title: "Vietnam", value: "Vietnam" },
  { title: "Western Sahara", value: "Western Sahara" },
  { title: "Yemen", value: "Yemen" },
  { title: "Zambia", value: "Zambia" },
  { title: "Zimbabwe", value: "Zimbabwe" },
];
export default COUNTRIES;